import request from '@/uilt/request'
import $ from 'jquery';
import { JSEncrypt } from 'jsencrypt';

//http请求配置
export const http = function (config) {
  var dtd = $.Deferred();
  $.ajax(config).then(
    function (data) {
      dtd.resolve(data); // 返回请求成功得到的数据
    },
    function (xhr) {
      dtd.reject(xhr); // 返回请求失败后的状态信息
    }
  );
  return dtd.promise();
};

/* 深拷贝 复杂对象
* 1、处理原始类型 Number String Boolean Symbol Null Undefined
* 2、处理不可遍历类型 Date RegExp Function
* 3、处理循环引用情况 WeakMap
* 4、处理可遍历类型 Set Map Array Object
* */
export const deepClone = (target, map = new WeakMap()) => {
  // 可遍历类型 Map Set Object Array
  const typeMap = '[object Map]';
  const typeSet = '[object Set]';
  const typeObject = '[object Object]';
  const typeArray = '[object Array]';
  // 非原始类型的 不可遍历类型  Date RegExp Function
  const typeDate = '[object Date]';
  const typeRegExp = '[object RegExp]';
  const typeFunction = '[object Function]';

  // 非原始类型的 不可遍历类型的 集合（原始类型已经被过滤了不用再考虑了）
  const simpleType = [typeDate, typeRegExp, typeFunction];

  // 是否是引用类型
  const isObject = (target) => {
    if (target === null) {
      return false;
    } else {
      const type = typeof target;
      return type === 'object' || type === 'function';
    }
  };

  // 获取标准类型
  const getType = (target) => {
    return Object.prototype.toString.call(target);
  };

  // 处理原始类型直接返回(Number BigInt String Boolean Symbol Undefined Null)
  if (!isObject(target)) {
    return target;
  }

  // 处理不可遍历类型
  const type = getType(target);
  if (simpleType.includes(type)) {
    switch (type) {
      case typeDate:
        // 日期
        return new Date(target);
      case typeRegExp:
        // 正则
        const reg = /\w*$/;
        const result = new RegExp(target.source, reg.exec(target)[0]);
        result.lastIndex = target.lastIndex; // lastIndex 表示每次匹配时的开始位置
        return result;
      case typeFunction:
        // 函数
        return target;
      default:
        return target;
    }
  }

  // 用于返回
  let cloneTarget;

  // 处理循环引用
  if (map.get(target)) {
    // 已经放入过map的直接返回
    return map.get(target)
  }

  // 处理可遍历类型
  switch (type) {
    case typeSet:
      // Set
      cloneTarget = new Set();
      map.set(target, cloneTarget);
      target.forEach((item) => {
        cloneTarget.add(deepClone(item, map))
      });
      return cloneTarget;
    case typeMap:
      // Map
      cloneTarget = new Map();
      map.set(target, cloneTarget);
      target.forEach((value, key) => {
        cloneTarget.set(key, deepClone(value, map))
      });
      return cloneTarget;
    case typeArray:
      // 数组
      cloneTarget = [];
      map.set(target, cloneTarget);
      target.forEach((item, index) => {
        cloneTarget[index] = deepClone(item, map)
      });
      return cloneTarget;
    case typeObject:
      // 对象
      cloneTarget = {};
      map.set(target, cloneTarget);
      [...Object.keys(target), ...Object.getOwnPropertySymbols(target)].forEach((item) => {
        cloneTarget[item] = deepClone(target[item], map)
      });
      return cloneTarget;
    default:
      return target;
  }
};

// 类型过滤器
export function typeFilter(row) {
  let value = row.value
  if (row.multiple || row.state) {
    let field = row.field
    switch (field) {
      case 'sex':
        value = row.value == 1 ? '男' : row.value == 2 ? '女' : '未知';
        break;
      case 'isMember':
        value = row.value == '是' ? 'SAAS会员' : '非SAAS会员';
        break;
      case 'ageRange':
        value = row.value == 1 ? '18~25岁' : row.value == 2 ? '26~30岁' : row.value == 3 ? '31~45岁' : '40~60岁';
        break;
      case 'staffType':
        value = row.value == 1 ? '已备案' : '未备案';
        break;
      case 'isFundPayment':
        value = row.value == 1 ? '已缴纳' : row.value == 2 ? '未缴纳' : '未知';
        break;
      case 'insuranceInsuredStatus':
        value = row.value == 1 ?
          '待参保' : row.value == 2 ?
            '已参保' : row.value == 3 ?
              '已删除' : row.value == 4 ?
                '参保终止' : row.value == 5 ?
                  '待补缴' : row.value == 6 ?
                    '补缴成功' : '未知';
        break;
    }
  }
  return value
}

// 文字换行
export function getFormatter(val, len) {
  let str = new String(val);
  let bytesCount = 0;
  let s = "";
  for (let i = 0; i < str.length; i++) {
    let c = str.charCodeAt(i);
    // 统计字符串的字符长度
    if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
      bytesCount++;
    } else {
      bytesCount += 2;
    }

    // 换行
    s += str.charAt(i);
    if (bytesCount >= len && i < str.length - 1) {
      s = s + '\n';
      // 重置
      bytesCount = 0;
    }
  }
  return s;
}

// 将数值取整为10的倍数
/**
 * 将数字取整为10的倍数
 * @param {Number} num 需要取整的值
 * @param {Boolean} ceil 是否向上取整
 * @param {Number} prec 需要用0占位的数量
 */
export function formatInt(num, ceil = true) {
  let prec = 2
  const len = String(num).length;
  if (len <= prec) {
    return num
  };
  const mult = Math.pow(10, prec);
  return ceil ? Math.ceil(num / mult) * mult : Math.floor(num / mult) * mult;
}

// 数字千分位 保留两位小数
export function changeNum(num, fixed = 0) {
  var str = num.toFixed(fixed);
  var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g
  return str.replace(reg, "$1,")
}

// 设置列表页初始数据
export function setDatas(ref) {
  let childDatas = JSON.parse(sessionStorage.getItem('childDatas'))
  return childDatas[ref]
}

// 设置详情参数
export function setBaseInfo(row, type) {
  row.tags = [];
  row.list = [];
  if (type == '1') {
    for (var i in row) {
      if (row[i] && typeof row[i] != 'object' && (i == 'sex' || i == 'ageRange' || i == 'adeptProd' || i == 'staffType')) {
        row.tags.push({ field: i, multiple: true, value: row[i] })
      } else if (row[i] && typeof row[i] != 'object' && (i == 'adeptProd' || i == 'cityName')) {
        row.tags.push({ field: i, value: row[i] })
      }
    }
    row.list = [
      { field: 'mobile', label: '手机号', value: row.mobile },
      { field: 'anmeldenAddress', label: '户籍所在地', value: row.anmeldenAddress },
      { field: 'registerDate', label: '注册时间', value: row.registerDate },
      { field: 'personalDetails', label: '备案履历', value: row.personalDetails },
      { field: 'idCard', label: '身份证号', value: row.idCardDecrypt },
      { field: 'personalPosition', label: '备案岗位', value: row.personalPosition },
    ]
  } else if (type == '2') {
    for (var i in row) {
      if (row[i] && typeof row[i] != 'object' && (i == 'terminalType' || i == 'terminalSubType')) {
        row.tags.push({ field: i, value: row[i] })
      }
    }
    row.list = [
      { field: 'filingTime', label: '建档时间', value: row.filingTime },
      { field: 'address', label: '详细地址', value: row.address },
      { field: 'contacts', label: '联系人', value: row.contacts },
      { field: 'maintainPharma', label: '维护的药企', value: row.maintainPharma },
      { field: 'contactTel', label: '联系人电话', value: row.contactTel },
      { field: 'maintainStaffs', label: '维护服务人员', value: row.maintainStaffs },
    ]
  } else if (type == '3') {
    for (var i in row) {
      // if (row[i] && typeof row[i] != 'object' && i == 'teamType') {
      //     row.tags.push({ field: i, value: row[i] })
      // } else
      if (row[i] && typeof row[i] != 'object' && i == 'isMember') {
        row.tags.push({ field: i, value: row[i], state: 1 })
      }
    }
    row.list = [
      { field: 'filingTime', label: '建档时间', value: row.filingTime },
      { field: 'address', label: '详细地址', value: row.address },
      { field: 'contacts', label: '联系人', value: row.contacts },
      { field: 'maintainPharma', label: '维护的药企', value: row.maintainPharma },
      { field: 'contactTel', label: '联系人电话', value: row.contactTel },
      { field: 'maintainStaffs', label: '维护服务人员', value: row.maintainStaffs },
    ]
  }
  return row
}

export function setColor(code, min, max) {
  const colors = ['#E0F2F2', '#DCEAEB', '#B8D7D8', '#81BBBD', '#4FA1A4', '#137174'];
  const gap = Math.ceil((max - min) / 6)
  let index = 0
  if (code <= (min + gap)) {
    index = 0
  } else if (code > min && code <= (min + gap * 2)) {
    index = 1
  } else if (code > (min + gap * 2) && code <= (min + gap * 3)) {
    index = 2
  } else if (code > (min + gap * 3) && code <= (min + gap * 4)) {
    index = 3
  } else if (code > (min + gap * 4) && code <= (min + gap * 5)) {
    index = 4
  } else if (code > (min + gap * 5) && code <= max) {
    index = 5
  }
  return colors[index] || '#888';
}

// 图片地址转base64
export const imgUrlToBase64 = (url, callback, outputFormat) => {
  var canvas = document.createElement('CANVAS')
  var ctx = canvas.getContext('2d')
  var img = new Image()
  img.crossOrigin = 'Anonymous'
  img.onload = function () {
    canvas.height = img.height
    canvas.width = img.width
    ctx.drawImage(img, 0, 0)
    var dataURL = canvas.toDataURL(outputFormat || 'image/png')
    //回调函数传递转换完成的base64编码
    callback(dataURL)
    canvas = null
  }
  img.src = url
}

const privateKey = '-----BEGIN RSA PRIVATE KEY-----MIICWgIBAAKBgFiv3Ko6rOBvWDK96tIExpdyuuQAGgZo0YmQxpT10hD3qu/MnNKlIJgo4+NwUHcwpleKE2DBOxgvCeMtUoP4FDWt8q18X+4+7t8p0D/57NhA0liNKQ/Ise6b5i293ht1XPen3XhR5xIcDNxauQ5vKqdwwzhoonsbJDtbowoinLQbAgMBAAECgYATcSIf01MYtHASV54FwnRCuS0NVJRf+VSOIsXV2/ncLF81yJZMe1Sk5rnmnzWUm36rzCIpYNLyn0U8ny/qrFTJmZK54956oSHyRYcklH2VtX/MCR7RgxdDBEXjJHuG7Hyk19E5lUyFdcF1IxEPadtoDHZj7Z2T8k8lKxDA8GnvgQJBAKBMESdn8Yf/0PTUwYnRvcXFqTg+ixPvwZzl+qtd+HXDXRekEctXo7zb14cJT2DqlgrT4lxYX6nJLzDYXYzBeUECQQCNote6gqkZSEQeHR2ePD4UrDAE6cI8QVhkiG7mjEOSE6M3CnWJkdvY LmtT+hzWJIWmLlX1dG8oGglmydGcBhpbAkAQUu7ERo+QO/r5k9kJwfRDebeb5LKhGx9qbPk0DmPJClYmnCy7uncQOoseU1JkGj+hZqZ8pPtI/RXzMXWFagaBAkA4QUuJ6sebIRbdFxdid+74awOPkADzych/9aiGrYNRC7ex7teMUoCNNrKuYhL+AveKb7D4ksxrkxvU1agJXmstAkAg4ZZMd+4yiXeiK9jUp6McDJAn3GXmV8nmuAb97cE481hRlp3K/QjTDHf0GdBOhGcRuGzFCvezygbu/kakIw6k-----END RSA PRIVATE KEY-----';
// 解密
export const decryptText = (text) => {
  let instance = new JSEncrypt();
  instance.setPrivateKey(privateKey);
  return instance.decrypt(text);
}

export const getNodeColor = (type) => {
  switch (type) {
    case 1:
      return { name: '人员', color: 'rgb(252, 90, 90)', rgb: '252, 90, 90', borderRgb: '254, 222, 222' };
    case 2:
      return { name: '医生', color: 'rgb(246, 139, 56)', rgb: '246, 139, 56', borderRgb: '253, 232, 215' };
    case 3:
      return { name: '联系人', color: 'rgb(219, 33, 117)', rgb: '219, 33, 117', borderRgb: '248, 211, 227' };
    case 4:
      return { name: '医院', color: 'rgb(78, 200, 71)', rgb: '78, 200, 71', borderRgb: '220, 244, 218' };
    case 5:
      return { name: '药店', color: 'rgb(16, 192, 138)', rgb: '16, 192, 138', borderRgb: '207, 242, 232' };
    case 6:
      return { name: '商业公司', color: 'rgb(19, 139, 236)', rgb: '19, 139, 236', borderRgb: '208, 232, 251' };
    case 7:
      return { name: '基层医疗', color: 'rgb(25, 164, 152)', rgb: '25, 164, 152', borderRgb: '209, 237, 234' };
    case 8:
      return { name: '生产企业', color: 'rgb(87, 111, 233)', rgb: '87, 111, 233', borderRgb: '221, 226, 251' };
    case 9:
      return { name: '产品', color: 'rgb(25, 193, 205)', rgb: '25, 193, 205', borderRgb: '209, 243, 245' };
    case 10:
      return { name: '科室', color: 'rgb(148, 199, 38)', rgb: '148, 199, 38', borderRgb: '234, 244, 212' };
    case 11:
      return { name: '部门', color: 'rgb(135, 105, 217)', rgb: '135, 105, 217', borderRgb: '231, 225, 247' };
    case 12:
      return { name: '生产厂商', color: 'rgb(23, 143, 231)', rgb: '23, 143, 231', borderRgb: '209, 233, 250' };
    default:
      return { name: '', color: '', rgb: '', borderRgb: '' };
  }
}

export const getLinkNet = (type) => {
  switch (type) {
    case '服务网络':
      return '1'
    case '触达网络':
      return '2'
    case '供应网络':
      return '3'
    case '销售网络':
      return '4'
    case '物流网络':
      return '5'
    case '服务人员':
      return '6'
    case '上级':
      return '7'
    case '下级':
      return '8'
    case '平级':
      return '9'
    case '科室':
      return '10'
    case '医生':
      return '11'
    case '部门':
      return '12'
    case '联系人':
      return '13'
    default:
      return ''
  }
}

export const linkColor = {
  'center': { color: '209,209,209', selectedColor: '51,23,183' },
  'staff': { color: '209,209,209', selectedColor: '252,90,90' },
  'product': { color: '209,209,209', selectedColor: '25,193,205' },
  'hospital': { color: '209,209,209', selectedColor: '78,200,71' },
  'pharmacy': { color: '209,209,209', selectedColor: '16,192,138' },
  'company': { color: '209,209,209', selectedColor: '19,139,236' },
  'medical': { color: '209,209,209', selectedColor: '25,164,152' },
  'department': { color: '209,209,209', selectedColor: '148,199,38' },
  'doctor': { color: '209,209,209', selectedColor: '246,139,56' },
  'division': { color: '209,209,209', selectedColor: '135,105,217' },
  'contact': { color: '209,209,209', selectedColor: '219,33,117' }
}

export const getLinkColor = (type) => {
  switch (type) {
    case '上级':
    case '下级':
    case '平级':
    case '服务人员':
    case '医生':
    case '联系人':
      return 'staff'
    case '科室':
    case '部门':
      return 'depart'
    case '触达网络':
      return 'reach'
    case '服务网络':
      return 'service'
    case '供应网络':
      return 'supply'
    case '销售网络':
      return 'sales'
    case '物流网络':
      return 'logistics'
    default:
      return ''
  }
}

export const getTargetColor = (type, name) => {
  switch (type) {
    case '1-1':
    case '1-2':
      return 'center'
    case '1-3':
    case '3-1-1':
    case '3-1-2':
    case '3-1-3':
      return 'staff'
    case '2-1':
      return name == '1' ? 'hospital' : 'center'
    case '2-2':
      return name == '1' ? 'pharmacy' : 'center'
    case '2-3':
      return name == '1' ? 'company' : 'center'
    case '2-4':
      return name == '1' ? 'medical' : 'center'
    case '2-1-1':
      return 'department'
    case '2-1-2':
      return 'doctor'
    case '2-3-1':
      return 'division'
    case '2-3-2':
      return 'contact'
    case '4-1':
      return name.type == 'sal_product' ? 'product' :  name.isCenter ? 'center' : 'company'
    case '4-2':
      return name.type == 'sal_product' ? 'product' : name.isCenter ? 'center' : 'hospital'
    case '4-3':
      return name.type == 'sal_product' ? 'product' : name.isCenter ? 'center' : 'pharmacy'
    case '4-4':
      return name.type == 'sal_product' ? 'product' : name.isCenter ? 'center' : 'medical'
    case '5-1':
      return name == 'sal_delivery' ? 'product' : 'company'
    case '5-2':
      return name == 'sal_delivery' ? 'product' : 'company'
    case '6-1':
    case '6-2':
      return 'product'
  }
}

/**
 * post请求，使用 data 属性来传参
 * get请求，使用 params 属性来传参
 * data 和 params 两个属性传参使用，并不是固定的，也可以调换使用
 * method 类型 参看 '@/uilt/new-axios.js' 内config设置
**/
// 文件上传
export const getImageUrl = (params) => request({
  url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file-include-filename`,
  method: 'post',
  data: params,
})

// 查看行政区划数据
export const getAreaInfo = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/area/query`,
  method: 'get',
  params
})

// 医药服务人员基本信息查询
export const getMedmiddleInfo = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-medmiddle-info`,
  method: 'post',
  data: params,
})

// 查看医药服务人员工作履历
export const getWorkInfo = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-work-info`,
  method: 'get',
  params
})

// 医药服务人员工作变更信息
export const getWorkChange = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-work-change`,
  method: 'post',
  data: params,
})

// 医药服务人员医院终端数据
export const getHospInfo = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-hosp-info`,
  method: 'post',
  data: params,
})

// 医药服务人员非医院终端数据
export const getNoHospInfo = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-nohosp-info`,
  method: 'post',
  data: params,
})

// 医药服务人员关系网数据
export const getLinks = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-links`,
  method: 'get',
  params,
})

// 服务人员拜访数据top5
export const getVisitList = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-visit`,
  method: 'get',
  params,
})

// 服务人员 掌握资源情况-渠道资源拜访查询
export const getChannelVisit = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-channel-visit`,
  method: 'post',
  data: params,
})

// 服务人员 掌握资源情况-产品资源查询
export const getProductOrder = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-product-order`,
  method: 'post',
  data: params,
})

// 服务人员 掌握资源情况-关系查询
export const getStaffLink = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-staff-link`,
  method: 'post',
  data: params,
})

// 服务人员 掌握资源情况-终端资源拜访查询
export const getTerminalVisit = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-terminal-visit`,
  method: 'post',
  data: params,
})

// 服务员评分列表
export const getScoreList = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-score-list`,
  method: 'get',
  params,
})

// 服务员评分雷达图
export const getScoreRadar = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-score-radar`,
  method: 'get',
  params,
})

// 服务员 人员关系网
export const getStaffLinksV2 = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-staff-links-v2`,
  method: 'get',
  params,
})

// 服务员 终端资源关系网
export const getTerminalLinksV2 = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-terminal-links-v2`,
  method: 'get',
  params,
})

// 服务员 渠道产品关系网
export const getChannelLinksV2 = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-channel-links-v2`,
  method: 'get',
  params,
})

// 获取同事关系网
export const getStaffColleagueLinks = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-staff-colleague-links`,
  method: 'get',
  params,
})

// 服务人员列表 地图搜索
export const getMedmiddleMapSearch = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/medmiddle/get-map-serach`,
  method: 'post',
  data: params,
})

// 获取终端基本信息
export const getTerminalInfo = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/terminal/get-terminal-info`,
  method: 'post',
  data: params,
})

// 获取终端采购能力
export const getPurchaseInfo = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/terminal/get-purchase-info`,
  method: 'post',
  data: params,
})

// 获取终端关系图数据
export const getTerminalLinks = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/terminal/get-links`,
  method: 'get',
  params,
})

// 获取商品排行榜数据
export const getRankingInfo = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/terminal/get-ranking-info`,
  method: 'get',
  params,
})

// 获取终端关系网-终端信息
export const getRelationInfo = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/terminal/get-relation-info`,
  method: 'post',
  data: params,
})

// 获取终端关系网-配送信息
export const getDistributeInfo = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/terminal/get-delivery-info`,
  method: 'post',
  data: params,
})

// 获取终端关系网-产品信息
export const getProductInfo = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/terminal/get-product-info`,
  method: 'post',
  data: params,
})

// 获取终端关系网 终端信息关系网
export const getLinksV2 = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/terminal/get-links-v2`,
  method: 'get',
  params,
})

// 获取终端关系网 终端配送关系网
export const getDistributeLinksV2 = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/terminal/get-delivery-links-v2`,
  method: 'get',
  params,
})

// 获取终端关系网 终端产品关系网
export const getProductLinksV2 = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/terminal/get-product-links-v2`,
  method: 'get',
  params,
})

// 终端列表 地图搜索
export const getTerminalMapSearch = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/terminal/get-map-serach`,
  method: 'post',
  data: params,
})

// 获取渠道基本信息
export const getChannelInfo = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/channel/get-channel-info`,
  method: 'post',
  data: params,
})

// 获取渠道人效能力信息
export const getSaleInfo = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/channel/get-sale-info`,
  method: 'post',
  data: params,
})

// 获取渠道关系网数据
export const getChannelLinks = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/channel/get-links`,
  method: 'get',
  params,
})

// 获取渠道供应链能力
export const getChainData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/channel/get-chain-data`,
  method: 'get',
  params,
})

// 获取会员渠道详情页统计数据
export const getNomemberDetailStat = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/channel/get-member-detail-stat`,
  method: 'get',
  params,
})

// 非会员渠道合作药企排行榜查询
export const getNomemberMedcircRankData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/channel/get-nomember-medcirc-rank`,
  method: 'get',
  params,
})

// 获取渠道关系网信息-产品资料
export const getProductData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/channel/get-channel-list`,
  method: 'post',
  data: params,
})

// 获取渠道关系网信息-配送资源
export const getDistributeData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/channel/get-delivery-list`,
  method: 'post',
  data: params,
})

// 获取渠道关系网信息-工业资源
export const getIndustryData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/channel/get-industrial-list`,
  method: 'post',
  data: params,
})

// 获取渠道关系网信息-人员资源
export const getStaffData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/channel/get-staffRelation-list`,
  method: 'post',
  data: params,
})

// 根据关键词查询会员渠道列表信息
export const getChannelList = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/channel/get-channel-list-keyword`,
  method: 'post',
  data: params,
})

// 渠道 人员产品关系网
export const getProdstaffLinksV2 = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/channel/get-prodstaff-links-v2`,
  method: 'get',
  params,
})

// 渠道 配送关系网
export const getDeliveryLinksV2 = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/channel/get-delivery-links-v2`,
  method: 'get',
  params,
})

// 渠道 工业关系网
export const getIndustrialLinksV2 = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/channel/get-industrial-links-v2`,
  method: 'get',
  params,
})

// 渠道列表 地图搜索
export const getChannelMapSearch = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/channel/get-map-serach`,
  method: 'post',
  data: params,
})

// 首页排行榜数据
export const getMapRankingData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/get-map-ranking-data`,
  method: 'get',
  params,
})

// 画像排行数据
export const getOrgRankingData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/get-org-ranking`,
  method: 'post',
  data: params,
})

// 获取首页地图数据
export const getMapData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/get-map-data`,
  method: 'get',
  params,
})

// 画像地图数据
export const getOrgMapData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/get-org-map-data`,
  method: 'post',
  data: params,
})

// 基本信息 画像数量 (业务员、终端、渠道)
export const getOrgTotalData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/get-org-total-stat`,
  method: 'post',
  data: params,
})

// 服务人拜访数据地图点
export const getVisitMapData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/get-visit-map-data`,
  method: 'get',
  params,
})

// 精确查询终端地图数据(终端和渠道)
export const getPointMapData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/get-point-map-data`,
  method: 'get',
  params,
})

// 渠道详情页关联到的终端位置地图数据
export const getChannelTerminalMapData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/get-channel-terminal-map-data`,
  method: 'get',
  params,
})

// 地图服务员列表数据top10
export const getOrgMedmiddleList = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/get-org-medmiddle-list`,
  method: 'post',
  data: params,
})

// 获取关系网起始节点数据
export const getStartData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/get-start-node`,
  method: 'get',
  params,
})

// 获取顶点的关系列表
export const getNodeEdge = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/get-node-edge`,
  method: 'get',
  params,
})

// 通过关系label获取关系网节点数据
export const getNodeByEdge = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/get-node-by-edge`,
  method: 'get',
  params,
})

// 获取不同类型关系统计
export const getLinkSummary = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/v2/get-link-summary`,
  method: 'get',
  params,
})

// 根据触达网络获取服务网络
export const getServiceByTouch = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/v2/get-service-by-touch`,
  method: 'get',
  params,
})

// 获取不同类型关系网top标签
export const getTopLabel = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/v2/get-top-label`,
  method: 'post',
  data: params,
})

// 获取不同类型关系网数据
export const getLinkData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/v2/get-link-data`,
  method: 'post',
  data: params,
})

// 清除关系网缓存
export const clearCache = () => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/v2/clean-cache-data`,
  method: 'post',
})

// 画像地图图层要素统计数据
export const getStatisticsMapData = (params) => request({
  url: `/${serverConfig.msBizdataStatisticsService}/index/get-org-map-data-statistics`,
  method: 'post',
  data: params,
})
